(self.webpackChunkuklash = self.webpackChunkuklash || []).push([ [ 592 ], {
  723: function(__unused_webpack_module, exports) {
    !function(e) {
      "use strict";
      function t(e) {
        var n, r, a = new Error(e);
        return n = a, r = t.prototype, Object.setPrototypeOf ? Object.setPrototypeOf(n, r) : n.__proto__ = r, 
        a;
      }
      function n(e, n, r) {
        var a = n.slice(0, r).split(/\n/), i = a.length, s = a[i - 1].length + 1;
        throw t(e += " at line " + i + " col " + s + ":\n\n  " + n.split(/\n/)[i - 1] + "\n  " + Array(s).join(" ") + "^");
      }
      t.prototype = Object.create(Error.prototype, {
        name: {
          value: "Squirrelly Error",
          enumerable: !1
        }
      });
      var r = new Function("return this")().Promise, a = !1;
      try {
        a = new Function("return (async function(){}).constructor")();
      } catch (e) {
        if (!(e instanceof SyntaxError)) throw e;
      }
      function i(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }
      function s(e, t, n) {
        for (var r in t) i(t, r) && (null == t[r] || "object" != typeof t[r] || "storage" !== r && "prefixes" !== r || n ? e[r] = t[r] : e[r] = s({}, t[r]));
        return e;
      }
      var c = /^async +/, o = /`(?:\\[\s\S]|\${(?:[^{}]|{(?:[^{}]|{[^}]*})*})*}|(?!\${)[^\\`])*`/g, l = /'(?:\\[\s\w"'\\`]|[^\n\r'\\])*?'/g, f = /"(?:\\[\s\w"'\\`]|[^\n\r"\\])*?"/g, u = /[.*+\-?^${}()|[\]\\]/g;
      function p(e) {
        return u.test(e) ? e.replace(u, "\\$&") : e;
      }
      function h(e, r) {
        r.rmWhitespace && (e = e.replace(/[\r\n]+/g, "\n").replace(/^\s+|\s+$/gm, "")), 
        o.lastIndex = 0, l.lastIndex = 0, f.lastIndex = 0;
        var a = r.prefixes, i = [ a.h, a.b, a.i, a.r, a.c, a.e ].reduce((function(e, t) {
          return e && t ? e + "|" + p(t) : t ? p(t) : e;
        }), ""), s = new RegExp("([|()]|=>)|('|\"|`|\\/\\*)|\\s*((\\/)?(-|_)?" + p(r.tags[1]) + ")", "g"), u = new RegExp("([^]*?)" + p(r.tags[0]) + "(-|_)?\\s*(" + i + ")?\\s*", "g"), h = 0, d = !1;
        function g(t, a) {
          var i, p = {
            f: []
          }, g = 0, v = "c";
          function m(t) {
            var a = e.slice(h, t), i = a.trim();
            if ("f" === v) "safe" === i ? p.raw = !0 : r.async && c.test(i) ? (i = i.replace(c, ""), 
            p.f.push([ i, "", !0 ])) : p.f.push([ i, "" ]); else if ("fp" === v) p.f[p.f.length - 1][1] += i; else if ("err" === v) {
              if (i) {
                var s = a.search(/\S/);
                n("invalid syntax", e, h + s);
              }
            } else p[v] = i;
            h = t + 1;
          }
          for ("h" === a || "b" === a || "c" === a ? v = "n" : "r" === a && (p.raw = !0, a = "i"), 
          s.lastIndex = h; null !== (i = s.exec(e)); ) {
            var y = i[1], x = i[2], b = i[3], w = i[4], F = i[5], S = i.index;
            if (y) "(" === y ? (0 === g && ("n" === v ? (m(S), v = "p") : "f" === v && (m(S), 
            v = "fp")), g++) : ")" === y ? 0 == --g && "c" !== v && (m(S), v = "err") : 0 === g && "|" === y ? (m(S), 
            v = "f") : "=>" === y && (m(S), h += 1, v = "res"); else if (x) if ("/*" === x) {
              var I = e.indexOf("*/", s.lastIndex);
              -1 === I && n("unclosed comment", e, i.index), s.lastIndex = I + 2;
            } else "'" === x ? (l.lastIndex = i.index, l.exec(e) ? s.lastIndex = l.lastIndex : n("unclosed string", e, i.index)) : '"' === x ? (f.lastIndex = i.index, 
            f.exec(e) ? s.lastIndex = f.lastIndex : n("unclosed string", e, i.index)) : "`" === x && (o.lastIndex = i.index, 
            o.exec(e) ? s.lastIndex = o.lastIndex : n("unclosed string", e, i.index)); else if (b) return m(S), 
            h = S + i[0].length, u.lastIndex = h, d = F, w && "h" === a && (a = "s"), p.t = a, 
            p;
          }
          return n("unclosed tag", e, t), p;
        }
        var v = function i(s, o) {
          s.b = [], s.d = [];
          var l, f = !1, p = [];
          function v(e, t) {
            e && (e = function(e, t, n, r) {
              var a, i;
              return "string" == typeof t.autoTrim ? a = i = t.autoTrim : Array.isArray(t.autoTrim) && (a = t.autoTrim[1], 
              i = t.autoTrim[0]), (n || !1 === n) && (a = n), (r || !1 === r) && (i = r), "slurp" === a && "slurp" === i ? e.trim() : ("_" === a || "slurp" === a ? e = String.prototype.trimLeft ? e.trimLeft() : e.replace(/^[\s\uFEFF\xA0]+/, "") : "-" !== a && "nl" !== a || (e = e.replace(/^(?:\n|\r|\r\n)/, "")), 
              "_" === i || "slurp" === i ? e = String.prototype.trimRight ? e.trimRight() : e.replace(/[\s\uFEFF\xA0]+$/, "") : "-" !== i && "nl" !== i || (e = e.replace(/(?:\n|\r|\r\n)$/, "")), 
              e);
            }(e, r, d, t)) && (e = e.replace(/\\|'/g, "\\$&").replace(/\r\n|\n|\r/g, "\\n"), 
            p.push(e));
          }
          for (;null !== (l = u.exec(e)); ) {
            var m, y = l[1], x = l[2], b = l[3] || "";
            for (var w in a) if (a[w] === b) {
              m = w;
              break;
            }
            v(y, x), h = l.index + l[0].length, m || n("unrecognized tag type: " + b, e, h);
            var F = g(l.index, m), S = F.t;
            if ("h" === S) {
              var I = F.n || "";
              r.async && c.test(I) && (F.a = !0, F.n = I.replace(c, "")), F = i(F), p.push(F);
            } else if ("c" === S) {
              if (s.n === F.n) return f ? (f.d = p, s.b.push(f)) : s.d = p, s;
              n("Helper start and end don't match", e, l.index + l[0].length);
            } else if ("b" === S) {
              f ? (f.d = p, s.b.push(f)) : s.d = p;
              var R = F.n || "";
              r.async && c.test(R) && (F.a = !0, F.n = R.replace(c, "")), f = F, p = [];
            } else if ("s" === S) {
              var T = F.n || "";
              r.async && c.test(T) && (F.a = !0, F.n = T.replace(c, "")), p.push(F);
            } else p.push(F);
          }
          if (!o) throw t('unclosed helper "' + s.n + '"');
          return v(e.slice(h, e.length), !1), s.d = p, s;
        }({
          f: []
        }, !0);
        if (r.plugins) for (var m = 0; m < r.plugins.length; m++) {
          var y = r.plugins[m];
          y.processAST && (v.d = y.processAST(v.d, r));
        }
        return v.d;
      }
      function d(e, t) {
        var n = h(e, t), r = "var tR='';" + (t.useWith ? "with(" + t.varName + "||{}){" : "") + x(n, t) + "if(cb){cb(null,tR)} return tR" + (t.useWith ? "}" : "");
        if (t.plugins) for (var a = 0; a < t.plugins.length; a++) {
          var i = t.plugins[a];
          i.processFnString && (r = i.processFnString(r, t));
        }
        return r;
      }
      function g(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n][0], a = t[n][1];
          e = (t[n][2] ? "await " : "") + "c.l('F','" + r + "')(" + e, a && (e += "," + a), 
          e += ")";
        }
        return e;
      }
      function v(e, t, n, r, a, i) {
        var s = "{exec:" + (a ? "async " : "") + y(n, t, e) + ",params:[" + r + "]";
        return i && (s += ",name:'" + i + "'"), a && (s += ",async:true"), s + "}";
      }
      function m(e, t) {
        for (var n = "[", r = 0; r < e.length; r++) {
          var a = e[r];
          n += v(t, a.res || "", a.d, a.p || "", a.a, a.n), r < e.length && (n += ",");
        }
        return n + "]";
      }
      function y(e, t, n) {
        return "function(" + t + "){var tR='';" + x(e, n) + "return tR}";
      }
      function x(e, t) {
        for (var n = 0, r = e.length, a = ""; n < r; n++) {
          var i = e[n];
          if ("string" == typeof i) a += "tR+='" + i + "';"; else {
            var s = i.t, c = i.c || "", o = i.f, l = i.n || "", f = i.p || "", u = i.res || "", p = i.b, h = !!i.a;
            if ("i" === s) {
              t.defaultFilter && (c = "c.l('F','" + t.defaultFilter + "')(" + c + ")");
              var d = g(c, o);
              !i.raw && t.autoEscape && (d = "c.l('F','e')(" + d + ")"), a += "tR+=" + d + ";";
            } else if ("h" === s) if (t.storage.nativeHelpers.get(l)) a += t.storage.nativeHelpers.get(l)(i, t); else {
              var y = (h ? "await " : "") + "c.l('H','" + l + "')(" + v(t, u, i.d, f, h);
              y += p ? "," + m(p, t) : ",[]", a += "tR+=" + g(y += ",c)", o) + ";";
            } else "s" === s ? a += "tR+=" + g((h ? "await " : "") + "c.l('H','" + l + "')({params:[" + f + "]},[],c)", o) + ";" : "e" === s && (a += c + "\n");
          }
        }
        return a;
      }
      var b = function() {
        function e(e) {
          this.cache = e;
        }
        return e.prototype.define = function(e, t) {
          this.cache[e] = t;
        }, e.prototype.get = function(e) {
          return this.cache[e];
        }, e.prototype.remove = function(e) {
          delete this.cache[e];
        }, e.prototype.reset = function() {
          this.cache = {};
        }, e.prototype.load = function(e) {
          s(this.cache, e, !0);
        }, e;
      }();
      function w(e, n, r, a) {
        if (n && n.length > 0) throw t((a ? "Native" : "") + "Helper '" + e + "' doesn't accept blocks");
        if (r && r.length > 0) throw t((a ? "Native" : "") + "Helper '" + e + "' doesn't accept filters");
      }
      var F = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      function S(e) {
        return F[e];
      }
      var I = new b({}), R = new b({
        each: function(e, t) {
          var n = "", r = e.params[0];
          if (w("each", t, !1), e.async) return new Promise((function(t) {
            !function e(t, n, r, a, i) {
              r(t[n], n).then((function(s) {
                a += s, n === t.length - 1 ? i(a) : e(t, n + 1, r, a, i);
              }));
            }(r, 0, e.exec, n, t);
          }));
          for (var a = 0; a < r.length; a++) n += e.exec(r[a], a);
          return n;
        },
        foreach: function(e, t) {
          var n = e.params[0];
          if (w("foreach", t, !1), e.async) return new Promise((function(t) {
            !function e(t, n, r, a, i, s) {
              a(n[r], t[n[r]]).then((function(c) {
                i += c, r === n.length - 1 ? s(i) : e(t, n, r + 1, a, i, s);
              }));
            }(n, Object.keys(n), 0, e.exec, "", t);
          }));
          var r = "";
          for (var a in n) i(n, a) && (r += e.exec(a, n[a]));
          return r;
        },
        include: function(e, n, r) {
          w("include", n, !1);
          var a = r.storage.templates.get(e.params[0]);
          if (!a) throw t('Could not fetch template "' + e.params[0] + '"');
          return a(e.params[1], r);
        },
        extends: function(e, n, r) {
          var a = e.params[1] || {};
          a.content = e.exec();
          for (var i = 0; i < n.length; i++) {
            var s = n[i];
            a[s.name] = s.exec();
          }
          var c = r.storage.templates.get(e.params[0]);
          if (!c) throw t('Could not fetch template "' + e.params[0] + '"');
          return c(a, r);
        },
        useScope: function(e, t) {
          return w("useScope", t, !1), e.exec(e.params[0]);
        }
      }), T = new b({
        if: function(e, t) {
          w("if", !1, e.f, !0);
          var n = "if(" + e.p + "){" + x(e.d, t) + "}";
          if (e.b) for (var r = 0; r < e.b.length; r++) {
            var a = e.b[r];
            "else" === a.n ? n += "else{" + x(a.d, t) + "}" : "elif" === a.n && (n += "else if(" + a.p + "){" + x(a.d, t) + "}");
          }
          return n;
        },
        try: function(e, n) {
          if (w("try", !1, e.f, !0), !e.b || 1 !== e.b.length || "catch" !== e.b[0].n) throw t("native helper 'try' only accepts 1 block, 'catch'");
          var r = "try{" + x(e.d, n) + "}", a = e.b[0];
          return r + "catch" + (a.res ? "(" + a.res + ")" : "") + "{" + x(a.d, n) + "}";
        },
        block: function(e, t) {
          return w("block", e.b, e.f, !0), "if(!" + t.varName + "[" + e.p + "]){tR+=(" + y(e.d, "", t) + ")()}else{tR+=" + t.varName + "[" + e.p + "]}";
        }
      }), E = new b({
        e: function(e) {
          var t = String(e);
          return /[&<>"']/.test(t) ? t.replace(/[&<>"']/g, S) : t;
        }
      }), j = {
        varName: "it",
        autoTrim: [ !1, "nl" ],
        autoEscape: !0,
        defaultFilter: !1,
        tags: [ "{{", "}}" ],
        l: function(e, n) {
          if ("H" === e) {
            var r = this.storage.helpers.get(n);
            if (r) return r;
            throw t("Can't find helper '" + n + "'");
          }
          if ("F" === e) {
            var a = this.storage.filters.get(n);
            if (a) return a;
            throw t("Can't find filter '" + n + "'");
          }
        },
        async: !1,
        storage: {
          helpers: R,
          nativeHelpers: T,
          filters: E,
          templates: I
        },
        prefixes: {
          h: "@",
          b: "#",
          i: "",
          r: "*",
          c: "/",
          e: "!"
        },
        cache: !1,
        plugins: [],
        useWith: !1
      };
      function H(e, t) {
        var n = {};
        return s(n, j), t && s(n, t), e && s(n, e), n.l.bind(n), n;
      }
      function O(e, n) {
        var r = H(n || {}), i = Function;
        if (r.async) {
          if (!a) throw t("This environment doesn't support async/await");
          i = a;
        }
        try {
          return new i(r.varName, "c", "cb", d(e, r));
        } catch (n) {
          throw n instanceof SyntaxError ? t("Bad template syntax\n\n" + n.message + "\n" + Array(n.message.length + 1).join("=") + "\n" + d(e, r)) : n;
        }
      }
      function _(e, t) {
        var n;
        return t.cache && t.name && t.storage.templates.get(t.name) ? t.storage.templates.get(t.name) : (n = "function" == typeof e ? e : O(e, t), 
        t.cache && t.name && t.storage.templates.define(t.name, n), n);
      }
      j.l.bind(j), e.compile = O, e.compileScope = x, e.compileScopeIntoFunction = y, 
      e.compileToString = d, e.defaultConfig = j, e.filters = E, e.getConfig = H, e.helpers = R, 
      e.nativeHelpers = T, e.parse = h, e.render = function(e, n, a, i) {
        var s = H(a || {});
        if (!s.async) return _(e, s)(n, s);
        if (!i) {
          if ("function" == typeof r) return new r((function(t, r) {
            try {
              t(_(e, s)(n, s));
            } catch (e) {
              r(e);
            }
          }));
          throw t("Please provide a callback function, this env doesn't support Promises");
        }
        try {
          _(e, s)(n, s, i);
        } catch (e) {
          return i(e);
        }
      }, e.templates = I, Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }(exports);
  },
  592: function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
    "use strict";
    __webpack_require__.r(__webpack_exports__);
    var squirrelly__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(723);
    __webpack_exports__.default = void (customElements.get("before-after") || customElements.define("before-after", class extends HTMLElement {
      container=this.querySelector(".max-h-0");
      grid=this.querySelector("[data-grid]");
      item=this.querySelector("[data-item]").innerHTML;
      page=1;
      Sqrl=__webpack_require__(723);
      constructor() {
        super();
      }
      load() {
        fetch(`https://shopify.covet.pics/api/v1/embed/${this.dataset.gallery}?page=${this.page}`, {
          method: "GET",
          headers: {
            Accept: "application/json"
          }
        }).then((response => response.json())).then((json => {
          json.success && json.items && 0 != json.items.length && (this.grid.innerHTML = this.grid.innerHTML + squirrelly__WEBPACK_IMPORTED_MODULE_0__.render(this.item, {
            items: json.items
          }), json.total_pages == this.page && this.querySelectorAll("[data-load]").forEach((button => button.parentNode.removeChild(button))), 
          this.container.classList.remove("max-h-0"), this.page = this.page + 1);
        })).catch((error => {
          console.error(error);
        }));
      }
      connectedCallback() {
        this.load(), this.querySelectorAll("[data-load]").forEach((button => button.addEventListener("click", (event => {
          event.preventDefault(), this.load();
        })))), squirrelly__WEBPACK_IMPORTED_MODULE_0__.filters.define("link", (s => window.routes.root_url + s.replace(s.split("products/")[0], ""))), 
        squirrelly__WEBPACK_IMPORTED_MODULE_0__.filters.define("money", (s => {
          if (!s) return "";
          try {
            return s ? Shopify.formatMoney(100 * parseFloat(s.match(/([0-9,]+(\.[0-9]{2})?)/)[0])) : "";
          } catch (e) {
            return console.log(s), console.warn(e), "";
          }
        }));
      }
    }));
  }
} ]);